import React, { useState } from "react";
import DatePicker from "react-datepicker";
import Editor from "../../../../partials/Editor";

const NewCarePlan = ({ onSubmit, onCancel }) => {
    const [model, setModel] = useState({
        header: {
            status: "Ongoing",
            dateCommenced: new Date(),
            typePlan: "",
            discipline: "",
            titleGroup: "",
            title: "",
        },
        carePlanAreas: [],
        reason: "",
        desc: "",
        goal: "",
        evidence: "",
        patientComment: "",
        intervention: "",
        evaluation: {
            nextDate: new Date(),
            evaluation: "",
        },
    });

    const [confirmed, setConfirmed] = useState(false);

    const onSelect = (value) => {
        let found = false;
        const _newModel = { ...model };
        for (let index = 0; index < _newModel.carePlanAreas.length; index++) {
            if (_newModel.carePlanAreas[index] === value) {
                found = true;
                // remove
                _newModel.carePlanAreas.splice(index, 1);
            }
        }
        if (!found) _newModel.carePlanAreas.push(value);

        setModel(_newModel);
    };

    return (
        <form
            onSubmit={(event) => {
                event.preventDefault();
                onSubmit({ model, confirmed });
            }}
        >
            <div className="row">
                <div className="col-3 bg-primary text-center">
                    <h5>Plan Header</h5>
                </div>
                <div className="col-12">
                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ width: "30%", backgroundColor: "aliceblue" }}>
                                    <strong>Date & Time Commenced*</strong>
                                </td>
                                <td>
                                    <div className="col-6">
                                        <DatePicker
                                            onChange={(date) =>
                                                setModel({
                                                    ...model,
                                                    header: {
                                                        ...model.header,
                                                        dateCommenced: date,
                                                    },
                                                })
                                            }
                                            selected={model.header.dateCommenced}
                                            className="form-control input-height"
                                            timeIntervals={5}
                                            showTimeSelect
                                            timeCaption="Time"
                                            dateFormat="MMMM d, yyyy h:mm aa"
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: "30%", backgroundColor: "aliceblue" }}>
                                    <strong>Type of Plan*</strong>
                                </td>
                                <td>
                                    <div className="col-md-6">
                                        <input
                                            onChange={({ currentTarget }) =>
                                                setModel({
                                                    ...model,
                                                    header: {
                                                        ...model.header,
                                                        typePlan: currentTarget.value,
                                                    },
                                                })
                                            }
                                            type="text"
                                            className="form-control input-height"
                                            placeholder="enter type ..."
                                            id="type-id"
                                            required
                                            aria-describedby="type-id"
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: "30%", backgroundColor: "aliceblue" }}>
                                    <strong>Discipline*</strong>
                                </td>
                                <td>
                                    <div className="col-md-6">
                                        <input
                                            onChange={({ currentTarget }) =>
                                                setModel({
                                                    ...model,
                                                    header: {
                                                        ...model.header,
                                                        discipline: currentTarget.value,
                                                    },
                                                })
                                            }
                                            type="text"
                                            className="form-control input-height"
                                            placeholder="enter discipline ..."
                                            id="Discipline-id"
                                            required
                                            aria-describedby="Discipline-id"
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: "30%", backgroundColor: "aliceblue" }}>
                                    <strong>Title Group*</strong>
                                </td>
                                <td>
                                    <div className="col-md-6">
                                        <input
                                            type="text"
                                            onChange={({ currentTarget }) =>
                                                setModel({
                                                    ...model,
                                                    header: {
                                                        ...model.header,
                                                        titleGroup: currentTarget.value,
                                                    },
                                                })
                                            }
                                            className="form-control input-height"
                                            placeholder="enter group ..."
                                            id="group-id"
                                            required
                                            aria-describedby="group-id"
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: "30%", backgroundColor: "aliceblue" }}>
                                    <strong>Title*</strong>
                                </td>
                                <td>
                                    <div className="col-md-6">
                                        <input
                                            onChange={({ currentTarget }) =>
                                                setModel({
                                                    ...model,
                                                    header: {
                                                        ...model.header,
                                                        title: currentTarget.value,
                                                    },
                                                })
                                            }
                                            type="text"
                                            className="form-control input-height"
                                            placeholder="enter title ..."
                                            id="title-id"
                                            required
                                            aria-describedby="title-id"
                                        />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="row">
                <div className="col-3 bg-primary text-center">
                    <h5>Physical Health Plan Areas</h5>
                </div>
                <table className="table table-bordered">
                    <tbody>
                        <tr>
                            <td className="text-right" style={{ width: "22%", backgroundColor: "aliceblue" }}>
                                <strong>Obesity</strong>
                            </td>
                            <td style={{ width: "10%" }}>
                                <div class="custom-control custom-checkbox">
                                    <input onChange={() => onSelect("Obesity")} type="checkbox" class="custom-control-input" id="Obesity" />
                                    <label class="custom-control-label" htmlFor="Obesity">
                                        Tick
                                    </label>
                                </div>
                            </td>
                            <td className="text-right" style={{ width: "22%", backgroundColor: "aliceblue" }}>
                                <strong>Diabetic</strong>
                            </td>
                            <td style={{ width: "10%" }}>
                                <div class="custom-control custom-checkbox">
                                    <input onChange={() => onSelect("Diabetic")} type="checkbox" class="custom-control-input" id="Diabetic" />
                                    <label class="custom-control-label" htmlFor="Diabetic">
                                        Tick
                                    </label>
                                </div>
                            </td>
                            <td className="text-right" style={{ width: "22%", backgroundColor: "aliceblue" }}>
                                <strong>C.O.P.D</strong>
                            </td>
                            <td style={{ width: "10%" }}>
                                <div class="custom-control custom-checkbox">
                                    <input onChange={() => onSelect("C.O.P.D")} type="checkbox" class="custom-control-input" id="C.O.P.D" />
                                    <label class="custom-control-label" htmlFor="C.O.P.D">
                                        Tick
                                    </label>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className="text-right" style={{ width: "22%", backgroundColor: "aliceblue" }}>
                                <strong>CHD</strong>
                            </td>
                            <td style={{ width: "10%" }}>
                                <div class="custom-control custom-checkbox">
                                    <input onChange={() => onSelect("CHD")} type="checkbox" class="custom-control-input" id="CHD" />
                                    <label class="custom-control-label" htmlFor="CHD">
                                        Tick
                                    </label>
                                </div>
                            </td>
                            <td className="text-right" style={{ width: "22%", backgroundColor: "aliceblue" }}>
                                <strong>Asthma</strong>
                            </td>
                            <td style={{ width: "10%" }}>
                                <div class="custom-control custom-checkbox">
                                    <input onChange={() => onSelect("Asthma")} type="checkbox" class="custom-control-input" id="Asthma" />
                                    <label class="custom-control-label" htmlFor="Asthma">
                                        Tick
                                    </label>
                                </div>
                            </td>
                            <td className="text-right" style={{ width: "22%", backgroundColor: "aliceblue" }}>
                                <strong>Alcohol Abuse</strong>
                            </td>
                            <td style={{ width: "10%" }}>
                                <div class="custom-control custom-checkbox">
                                    <input onChange={() => onSelect("Alcohol Abuse")} type="checkbox" class="custom-control-input" id="Alcohol Abuse" />
                                    <label class="custom-control-label" htmlFor="Alcohol Abuse">
                                        Tick
                                    </label>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className="text-right" style={{ width: "22%", backgroundColor: "aliceblue" }}>
                                <strong>Epilepsy</strong>
                            </td>
                            <td style={{ width: "10%" }}>
                                <div class="custom-control custom-checkbox">
                                    <input onChange={() => onSelect("Epilepsy")} type="checkbox" class="custom-control-input" id="Epilepsy" />
                                    <label class="custom-control-label" htmlFor="Epilepsy">
                                        Tick
                                    </label>
                                </div>
                            </td>
                            <td className="text-right" style={{ width: "22%", backgroundColor: "aliceblue" }}>
                                <strong>Hypertension</strong>
                            </td>
                            <td style={{ width: "10%" }}>
                                <div class="custom-control custom-checkbox">
                                    <input onChange={() => onSelect("Hypertension")} type="checkbox" class="custom-control-input" id="Hypertension" />
                                    <label class="custom-control-label" htmlFor="Hypertension">
                                        Tick
                                    </label>
                                </div>
                            </td>
                            <td className="text-right" style={{ width: "22%", backgroundColor: "aliceblue" }}>
                                <strong>Illegal Drug use</strong>
                            </td>
                            <td style={{ width: "10%" }}>
                                <div class="custom-control custom-checkbox">
                                    <input onChange={() => onSelect("Illegal Drug use")} type="checkbox" class="custom-control-input" id="illegal Drug use" />
                                    <label class="custom-control-label" htmlFor="illegal Drug use">
                                        Tick
                                    </label>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className="text-right" style={{ width: "22%", backgroundColor: "aliceblue" }}>
                                <strong>Dyslipidemia</strong>
                            </td>
                            <td style={{ width: "10%" }}>
                                <div class="custom-control custom-checkbox">
                                    <input onChange={() => onSelect("Dyslipidemia")} type="checkbox" class="custom-control-input" id="Dyslipidemia" />
                                    <label class="custom-control-label" htmlFor="Dyslipidemia">
                                        Tick
                                    </label>
                                </div>
                            </td>
                            <td className="text-right" style={{ width: "22%", backgroundColor: "aliceblue" }}>
                                <strong>Hypothyroid</strong>
                            </td>
                            <td style={{ width: "10%" }}>
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" onChange={() => onSelect("Hypothyroid")} class="custom-control-input" id="Hypothyroid" />
                                    <label class="custom-control-label" htmlFor="Hypothyroid">
                                        Tick
                                    </label>
                                </div>
                            </td>
                            <td className="text-right" style={{ width: "22%", backgroundColor: "aliceblue" }}>
                                <strong>Dementia</strong>
                            </td>
                            <td style={{ width: "10%" }}>
                                <div class="custom-control custom-checkbox">
                                    <input onChange={() => onSelect("Dementia")} type="checkbox" class="custom-control-input" id="Dementia" />
                                    <label class="custom-control-label" htmlFor="Dementia">
                                        Tick
                                    </label>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className="text-right" style={{ width: "22%", backgroundColor: "aliceblue" }}>
                                <strong>Other</strong>
                            </td>
                            <td style={{ width: "10%" }}>
                                <div class="custom-control custom-checkbox">
                                    <input onChange={() => onSelect("Other")} type="checkbox" class="custom-control-input" id="other" />
                                    <label class="custom-control-label" htmlFor="other">
                                        Tick
                                    </label>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="row">
                <div className="col-3 bg-primary text-center">
                    <h5>Plan Detail</h5>
                </div>
                <div className="col-12">
                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ width: "30%", backgroundColor: "aliceblue" }}>
                                    <strong>Reason for Careplan*</strong>
                                </td>
                                <td>
                                    <div className="col-md-12">
                                        <input
                                            onChange={({ currentTarget }) =>
                                                setModel({
                                                    ...model,
                                                    reason: currentTarget.value,
                                                })
                                            }
                                            type="text"
                                            className="form-control input-height"
                                            placeholder="enter reason ..."
                                            id="reason-id"
                                            required
                                            aria-describedby="reason-id"
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: "30%", backgroundColor: "aliceblue" }}>
                                    <strong>Description of Identified Need*</strong>
                                </td>
                                <td>
                                    <div className="col-md-12">
                                        <textarea
                                            onChange={({ currentTarget }) =>
                                                setModel({
                                                    ...model,
                                                    desc: currentTarget.value,
                                                })
                                            }
                                            name="description-id"
                                            id="description-id"
                                            className="form-control form-control-textarea"
                                            rows="4"
                                            placeholder="enter description"
                                        ></textarea>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: "30%", backgroundColor: "aliceblue" }}>
                                    <strong>Planned Goals/Aim*</strong>
                                </td>
                                <td>
                                    <div className="col-md-12">
                                        <textarea
                                            onChange={({ currentTarget }) =>
                                                setModel({
                                                    ...model,
                                                    goal: currentTarget.value,
                                                })
                                            }
                                            name="goal-id"
                                            id="goal-id"
                                            className="form-control form-control-textarea"
                                            rows="4"
                                            placeholder="enter goal/aim"
                                        ></textarea>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: "30%", backgroundColor: "aliceblue" }}>
                                    <strong>Intervention*</strong>
                                </td>
                                <td>
                                    <div className="col-md-12">
                                        <Editor
                                            placeholder="enter intervention .. "
                                            height={250}
                                            onChange={(_inter) =>
                                                setModel({
                                                    ...model,
                                                    intervention: _inter,
                                                })
                                            }
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: "30%", backgroundColor: "aliceblue" }}>
                                    <strong>Evidence/Research for Intervention*</strong>
                                </td>
                                <td>
                                    <div className="col-md-12">
                                        <textarea
                                            onChange={({ currentTarget }) =>
                                                setModel({
                                                    ...model,
                                                    evidence: currentTarget.value,
                                                })
                                            }
                                            name="evidence-id"
                                            id="evidence-id"
                                            className="form-control form-control-textarea"
                                            rows="4"
                                            placeholder="enter evidence"
                                        ></textarea>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: "30%", backgroundColor: "aliceblue" }}>
                                    <strong>Patient Comment / Evidence of involvement in forming this plan*</strong>
                                </td>
                                <td>
                                    <div className="col-md-12">
                                        <Editor
                                            placeholder="enter patient comment .. "
                                            height={250}
                                            onChange={(_comment) =>
                                                setModel({
                                                    ...model,
                                                    patientComment: _comment,
                                                })
                                            }
                                        />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="row">
                <div className="col-3 bg-primary text-center">
                    <h5>Evaluation!</h5>
                </div>
                <div className="col-12">
                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ width: "30%", backgroundColor: "aliceblue" }}>
                                    <strong>Next Evaluation Alert Date*</strong>
                                </td>
                                <td>
                                    <div className="col-12">
                                        <DatePicker
                                            onChange={(date) =>
                                                setModel({
                                                    ...model,
                                                    evaluation: {
                                                        ...model.evaluation,
                                                        nextDate: date,
                                                    },
                                                })
                                            }
                                            selected={model.evaluation.nextDate}
                                            className="form-control input-height"
                                            timeIntervals={5}
                                            showTimeSelect
                                            timeCaption="Time"
                                            dateFormat="MMMM d, yyyy h:mm aa"
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: "30%", backgroundColor: "aliceblue" }}>
                                    <strong>Evaluation (Please detail of the patient involvement in the evaluation)*</strong>
                                </td>
                                <td>
                                    <div className="col-12">
                                        <Editor
                                            height={250}
                                            onChange={(_note) =>
                                                setModel({
                                                    ...model,
                                                    evaluation: {
                                                        ...model.evaluation,
                                                        evaluation: _note,
                                                    },
                                                })
                                            }
                                            placeholder="Enter evaluation here.."
                                        />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="form-group">
                <div className="custom-control custom-checkbox custom-control-inline">
                    <input type="checkbox" onChange={() => setConfirmed(!confirmed)} id="confirmed" name="confirmed" className="custom-control-input" />
                    <label className="custom-control-label" htmlFor="confirmed">
                        Confirm on submission
                    </label>
                </div>
            </div>
            <div className="form-group text-center mt-5">
                <button type="submit" className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 margin-right-10 btn-circle btn-success">
                    Submit <i className="material-icons">arrow_right_alt</i>
                </button>
                <button type="button" onClick={onCancel} className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 margin-left-10 btn-circle btn-default">
                    <i className="material-icons text-danger">cancel</i> Cancel
                </button>
            </div>
        </form>
    );
};

export default NewCarePlan;
